import {
    Tableau,
    TableauBody,
    TableauCell,
    TableauHeader,
    TableauHeaderCell,
    TableauRow,
} from '@si-armes/dsfr-react';

import React from 'react';
import PropTypes from 'prop-types';
import { entetesHistorique } from './constantes';

const TableauHistorique = ({ armes, ordreTri, setOrdreTri, champTri, setChampTri }) => {
    return (
        <Tableau
            avecBordure
            role="table"
            caption="Hitorique des armes du détenteur - Appuyer sur un entete pour trier la colonne associée"
            noCaption
        >
            <TableauHeader>
                <TableauRow>
                    {entetesHistorique.map((title) => (
                        <TableauHeaderCell
                            ordreTri={champTri === title.field ? ordreTri : undefined}
                            onClick={() => {
                                if (champTri === title.field) {
                                    setOrdreTri((old) => (old === 'ASC' ? 'DESC' : 'ASC'));
                                } else {
                                    setOrdreTri('ASC');
                                    setChampTri(title.field);
                                }
                            }}
                            scope="col"
                            key={title.field}
                        >
                            {title.header}
                        </TableauHeaderCell>
                    ))}
                </TableauRow>
            </TableauHeader>
            <TableauBody>
                {armes.map((arme) => {
                    return (
                        <TableauRow>
                            {entetesHistorique.map((ti) => (
                                <TableauCell>{arme[ti.field]}</TableauCell>
                            ))}
                        </TableauRow>
                    );
                })}
            </TableauBody>
        </Tableau>
    );
};

TableauHistorique.propTypes = {
    armes: PropTypes.array.isRequired,
    ordreTri: PropTypes.string.isRequired,
    setOrdreTri: PropTypes.func.isRequired,
    champTri: PropTypes.string.isRequired,
    setChampTri: PropTypes.func.isRequired,
};

export default TableauHistorique;
